
export const CONDITIONS = (type) => {
    switch (type) {
    case "start":
        return [
            {
                label: "Manually Start",
                value: "manually_start"
            },
            {
                label: "Attribute",
                value: "attribute"
            }
        ];
    case "end":
        return [
            {
                label: "Goal",
                value: "goal"
            },
            {
                label: "Attribute",
                value: "attribute"
            },
            {
                label: "Event",
                value: "event"
            }
        ];
    case "goal":
        return [
            {
                label: "Attribute",
                value: "attribute"
            },
            {
                label: "Event",
                value: "event"
            }
        ];
    default:
        return [];
    }
};

export const CONDITION_NAME  = (condition) => {
    switch (condition) {
    case "goal":
        return [
            {
                label: "Goal Achieved",
                value: "goal_achieved"
            }
        ];
    case "attribute":
        return [
            {
                label: "MRR",
                value: "mrr"
            }
        ];
    case "event":
        return [
            {
                label: "Campaign",
                value: "campaign"
            }
        ];
    default:
        return [];
    }
};

export const OPERATORS = [
    {
        label: "Equals to",
        value: "equals_to"
    },
    {
        label: "Greater than",
        value: "greater_than"
    },
    {
        label: "Greater than or equal to",
        value: "greater_than_or_equals_to"
    },
  
    {
        label: "Less than or equal to",
        value: "less_than_or_equals_to"
    },
    {
        label: "Less than",
        value: "less_than"
    }
];

export const VALUES = (name) => {
    switch (name) {
    case "goal_achieved":
        return [
            {
                label: "All Achieved",
                value: "all_achieved"
            }
        ];
    case "campaign":
        return [
            { 
                label: "Has been performed",
                value: "has_been_performed"
            },
            {
                label: "Has never been performed",
                value: "has_never_been_performed"
            }
        ];
        
    default:
        return [];
    }

};
  